import { useMutation } from '@tanstack/react-query';

import { createRequestPaymentByCustomerCardId } from '../services';

export function useCreateRequestPaymentByCustomerCardId() {
  return useMutation({
    mutationFn: createRequestPaymentByCustomerCardId,
  });
}
